import axios from '@/libs/api.request'

export const getSimilarParts = (componentType, partId) => {
  componentType = componentType.replace('_', '-')
  return axios.request({
    method: 'get',
    url: `/parts/${componentType}/${partId}/similar-parts`
  })
}
